import React from 'react';
import Menu from '../../nav/menu';
import Footer from '../../nav/footer';
import useMedia from 'use-media';
import {
    title,
    body1,
    body2
} from './text';
import CoffeComponent from '../../components/coffee';
import StylishHeader from '../../components/stylishHeader';
import CarroucelImg from '../../components/carroucelImg';
import { generalStyleDivs } from '../../styles.js';

function PerfectCoffeePage() {
    const isLargeScreen = useMedia('(min-width: 601px)');
    const isSmallScreen = useMedia('(max-width: 600px)');

    const carroucelImg1 = [
        {
            url: '/img/coffeBag1.png'
        },
        {
            url: '/img/coffeBag2.png'
        },
        {
            url: '/img/coffeBag3.png'
        }
    ];
    const carroucelImg2 = [
        {
            url: '/img/grindCoffee.png'
        },
        {
            url: '/img/wholeGrainCoffee.png'
        }
    ];
    const row ={
        display: "flex",
        textAlign: "justify",
        marging:"10px"
    }
    return (
        <div>

        {isLargeScreen &&
            <div>
                <Menu/>
                <div style={{ width: "100%", justifyContent: "center", display: "flex", backgroundColor: "#F4DFBB" }}>
                    <div id="mainArea" style={{ display: "flex", maxWidth: "1200px", backgroundImage: "url(./img/backgroundSite.png)", backgroundRepeat: "repeat", flexFlow: "column" }}>
                        <div style={{ width: "100%" }}>
                            <div style={{ ...row, flexFlow: "column", margin: "10px" }}>
                                <StylishHeader headerText="Find you perfect Coffee" />
                                <div style={{ fontSize: "x-large", ...generalStyleDivs }}>
                                    <p style={{ padding: "10px" }}>{body1}</p>
                                </div>
                            </div>
                        </div>
                        <div style={{ width: "100%" }}>
                            <div style={{ ...row, flexFlow: "column"  }}>
                                <StylishHeader headerText="Types of coffee toast we offer" />
                                <CoffeComponent/>
                            </div>
                        </div>
                        <div style={{ width: "100%",display: "flex", flexFlow: "row" }}>
                                <div style={{ width: "80%", margin: "10px" }}>
                                    <div style={{ fontSize: "x-large", lineHeight: "40px", textAlign: "justify", display: "flex", height: "100%", alignItems: "center", ...generalStyleDivs}}>
                                        <span style={{ padding: "10px" }}>{body2}</span>
                                    </div>
                                </div>
                                <div style={{ width: "20%" }}>
                                    <div>
                                        <img src="img/grindCoffee.png" width="100%" height="250" style={{ maxHeight: "200px", paddingBottom: "15px" }} alt=""/>
                                        <img src="img/wholeGrainCoffee.png" width="100%" height="250" style={{ maxHeight: "200px" }} alt=""/>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
            
        }
        {isSmallScreen &&
         <div style={{ justifyContent: "center", display: "flex", backgroundColor: "#F4DFBB",flexFlow: "column" }}>
            <Menu/>
            <div style={{ padding: "10px", textAlign: "justify", backgroundImage: "url(./img/backgroundSite.png)", backgroundRepeat: "repeat" }}>
                <CarroucelImg carroucelImg={carroucelImg1} isSmallScreen={isSmallScreen} isLargeScreen={isLargeScreen} arrows="black"/>
                <StylishHeader headerText={title} />
                <div style={{ fontSize: "x-large",display: "flex", ...generalStyleDivs }}>
                    <span style={{ padding: "10px" }}>{body1}</span>
                </div>
                <div style={{ height: "420px" }}>
                    <StylishHeader headerText="Our type of toast" />
                    <CoffeComponent/>
                </div>
                <div style={{ fontSize: "x-large" }}>
                    <div style={{ display: "flex", ...generalStyleDivs }}>
                        <span style={{ padding: "10px" }}>{body2}</span>
                    </div>
                </div>
                <CarroucelImg carroucelImg={carroucelImg2} isSmallScreen={isSmallScreen} isLargeScreen={isLargeScreen} arrows="black"/>
            </div>
            <Footer/>
         </div>
        }
        </div>
    )
    
}

export default PerfectCoffeePage;